enum ProjectStatus {
	New = "New",
	InProgress = "InProgress",
	Finished = "Finished"
}

export default ProjectStatus;
